module.exports = __webpack_public_path__ + "img/card-bg.da3c36ad.png";